<ng-template ngIf [ngIf]="!switcher">

    <input class="hidden-button" type="checkbox" [attr.id]="id || null" [name]="name" [(ngModel)]="value">
    <div class="button" [tabindex]="tabindex" [class.clicked]="value">
        <span class="check-mark"></span>
    </div>
</ng-template>
<ng-template ngIf [ngIf]="switcher">
    <label class="toggle-button__container">
        <input type="checkbox" (click)="modeToggleSwitch()"  class="mode-toggle__input" />
        <span class="mode-toggle__bg" [class.mode-toggle__bg-checked]="value"></span>
        <span class="mode-toggle__circle"  [class.mode-toggle__circle-checked]="value"></span>
    </label>
</ng-template>
<span class="label" #label [hidden]="!showLabel">
    <ng-content></ng-content>
</span>
